import * as Immutable from "immutable";
import isDeepEqual from "stores/isDeepEqual";
import isEqualForSearch from "views/stores/isEqualForSearch";
import SortConfig from "views/logic/aggregationbuilder/SortConfig";
import Direction from "views/logic/aggregationbuilder/Direction";
import { TIMESTAMP_FIELD } from "views/Constants";
import WidgetConfig from "./WidgetConfig";
export const defaultSortDirection = Direction.Descending;
export const defaultSort = [new SortConfig(SortConfig.PIVOT_TYPE, TIMESTAMP_FIELD, defaultSortDirection)];
export default class MessagesWidgetConfig extends WidgetConfig {
  constructor(fields, showMessageRow, showSummary, decorators, sort) {
    super();
    this._value = {
      decorators,
      fields: fields.slice(0),
      showMessageRow,
      showSummary,
      sort: sort && sort.length > 0 ? sort : defaultSort
    };
  }
  get decorators() {
    return this._value.decorators;
  }
  get fields() {
    return this._value.fields;
  }
  get sort() {
    return this._value.sort;
  }
  get showMessageRow() {
    return this._value.showMessageRow;
  }
  get showSummary() {
    return this._value.showSummary;
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
  toJSON() {
    const { decorators, fields, showMessageRow, showSummary, sort } = this._value;
    return {
      decorators,
      fields,
      show_message_row: showMessageRow,
      show_summary: showSummary,
      sort
    };
  }
  equals(other) {
    return other instanceof MessagesWidgetConfig && isDeepEqual(this.decorators, other.decorators) && isDeepEqual(this.fields, other.fields) && isDeepEqual(this.sort, other.sort) && this.showMessageRow === other.showMessageRow && this.showSummary === other.showSummary;
  }
  equalsForSearch(other) {
    return other instanceof MessagesWidgetConfig && isEqualForSearch(other.decorators, this.decorators) && isEqualForSearch(other.sort, this.sort);
  }
  static builder() {
    return new Builder().decorators([]).fields([]).sort([]);
  }
  static fromJSON(value) {
    const { decorators, show_message_row, show_summary, fields, sort } = value;
    return new MessagesWidgetConfig(fields, show_message_row, show_summary, decorators, sort.map(SortConfig.fromJSON));
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  decorators(value) {
    return new Builder(this.value.set("decorators", value.slice(0)));
  }
  fields(value) {
    return new Builder(this.value.set("fields", value.slice(0)));
  }
  showMessageRow(value) {
    return new Builder(this.value.set("showMessageRow", value));
  }
  showSummary(value) {
    return new Builder(this.value.set("showSummary", value));
  }
  sort(sorts) {
    return new Builder(this.value.set("sort", sorts));
  }
  build() {
    const { decorators, fields, showMessageRow, showSummary, sort } = this.value.toObject();
    return new MessagesWidgetConfig(fields, showMessageRow, showSummary, decorators, sort);
  }
}
